import React from 'react'
import styled from 'styled-components'
import { LabelSemiBoldMedium, LabelSmall } from './base-ui/FontsV2'
import { useTranslation } from 'react-i18next'

export default function DineInSelfCheckoutAlert() {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <div>
        <LabelSemiBoldMedium>{t('checkout.dineInSelfCheckoutEnabled.title')} </LabelSemiBoldMedium>
        <LabelSmall>{t('checkout.dineInSelfCheckoutEnabled.description')} </LabelSmall>
      </div>
      <img src="/assets/dine-in/checkout_by_self.png" width={32} height={32} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-radius: 8px;
  padding: ${({ theme }) => theme.spacing.verticalSpacingS} ${({ theme }) => theme.spacing.horizontalSpacingL};
  background-color: ${({ theme }) => theme.colors.infoLightWhite};
`
